import type { PopupTeaserConfig } from '@onetext/api';
import { FONT_WEIGHT, TEXT_TRANSFORM } from '@onetext/api';

export const teaserConfig : PopupTeaserConfig = {
    content: '',
    enabled: true,
    style:   {
        color: {
            text: {
                base:  '#fff',
                hover: '#fff'
            },
            background: {
                base:  '#000',
                hover: '#000'
            }
        },
        dimension: {
            textTransform: TEXT_TRANSFORM.UPPERCASE,
            height:        '48px',
            borderRadius:  '50px',
            fontSize:      '14px',
            lineHeight:    '1em',
            letterSpacing: '3px',
            fontWeight:    FONT_WEIGHT._400
        }
    }
};
